module.exports = __webpack_public_path__ + "img/image_9.74794c26.png";